export default __webpack_public_path__ + "static/media/back01.c502df0c.jpg";